import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { ReachStakeholder } from '../../../services/reachService';

interface Props {
  stakeholder: ReachStakeholder;
  onEdit: (s: ReachStakeholder) => void;
}

function initials(name: string): string {
  return name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
}

export const StakeholderMapNode: React.FC<Props> = ({ stakeholder, onEdit }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: stakeholder.id,
  });

  const style: React.CSSProperties = {
    position: 'absolute',
    left: `${stakeholder.x * 100}%`,
    top: `${(1 - stakeholder.y) * 100}%`,
    transform: `translate(calc(-50% + ${transform?.x ?? 0}px), calc(-50% + ${transform?.y ?? 0}px))`,
    zIndex: isDragging ? 50 : 10,
    cursor: isDragging ? 'grabbing' : 'grab',
    touchAction: 'none',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className={`flex flex-col items-center gap-1 group select-none ${isDragging ? 'opacity-80' : ''}`}
    >
      <div
        className="w-10 h-10 rounded-full flex items-center justify-center text-white text-xs font-bold shadow-md border-2 border-white ring-2 ring-white/50 transition-transform group-hover:scale-110"
        style={{ backgroundColor: stakeholder.color || '#00c7c4' }}
        onDoubleClick={(e) => { e.stopPropagation(); onEdit(stakeholder); }}
        title="Double-click to edit"
      >
        {initials(stakeholder.name)}
      </div>
      <div className="bg-white/90 rounded-md px-1.5 py-0.5 shadow-sm text-center max-w-[100px]">
        <p className="text-[10px] font-semibold text-navy leading-tight truncate">{stakeholder.name}</p>
        <p className="text-[9px] text-slate-500 leading-tight truncate">{stakeholder.role}</p>
      </div>
    </div>
  );
};
